import {
    AreaChartOutlined,
    BarChartOutlined,
    DotChartOutlined,
    FieldNumberOutlined,
    LineChartOutlined,
    PieChartOutlined,
    TableOutlined
} from "@ant-design/icons";
import React from "react";

export const ChartTypes = [
    {name: 'line', title: 'График', icon: () => <LineChartOutlined/>},
    {name: 'area', title: 'Область', icon: () => <AreaChartOutlined/>},
    {name: 'bar', title: 'Столбчатая', icon: () => <BarChartOutlined/>},
    {name: 'pie', title: 'Круговая', icon: () => <PieChartOutlined/>},
    {name: 'table', title: 'Таблица', icon: () => <TableOutlined/>},
    {name: 'number', title: 'Число', icon: () => <FieldNumberOutlined/>},
    {name: 'map', title: 'Карта', icon: () => <DotChartOutlined/>},
    {name: 'dot', title: 'Точечная', icon: () => <DotChartOutlined/>},
];